import { render, staticRenderFns } from "./costList.vue?vue&type=template&id=4ec9c0be&scoped=true&"
import script from "./costList.vue?vue&type=script&lang=js&"
export * from "./costList.vue?vue&type=script&lang=js&"
import style0 from "./costList.vue?vue&type=style&index=0&id=4ec9c0be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9c0be",
  null
  
)

export default component.exports